import { IoIosVolumeOff, IoIosVolumeHigh, IoIosPlay, IoIosPause } from "react-icons/io";

import styles from "./VideoPlayer.module.css";

import { useEffect, useState, useRef } from "react";
import Hls from "hls.js";

export default function VideoPlayer({
  src,
  poster,
  autoPlay = false,
  loop,
  style,
  muted = false,
  controls = false,
}) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.controls = false;
    let hls;

    if (Hls.isSupported()) {
      // Prefer hls.js wherever MSE is available. Chrome 152+ reports "maybe"
      // for native HLS via canPlayType but then fails to play Mux streams
      // (MEDIA_ERR_SRC_NOT_SUPPORTED), so native playback is the fallback only.
      hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Safari (especially iOS) has no MSE but supports HLS natively
      video.src = src;
    } else {
      console.error(
        "This is an old browser that does not support MSE https://developer.mozilla.org/en-US/docs/Web/API/Media_Source_Extensions_API"
      );
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [src, videoRef]);

  const [mute, setMute] = useState(muted);
  const [playing, setPlaying] = useState(autoPlay);

  const toggleMute = () => {
    videoRef.current.muted = !videoRef.current.muted;
    setMute(!mute);
  };

  const togglePlay = () => {
    playing ? videoRef.current.pause() : videoRef.current.play();
    setPlaying(!playing);
  };
  return (
    <div style={style} className={styles.videoWrapper}>
      {controls && (
        <div className={styles.videoControls}>
          <button className={styles.videoButton} onClick={togglePlay}>
            {playing ? <IoIosPause size="1.25em" /> : <IoIosPlay size="1.25em" />}
          </button>
          <button className={styles.videoButton} onClick={toggleMute}>
            {mute ? <IoIosVolumeOff size="1.25em" /> : <IoIosVolumeHigh size="1.25em" />}
          </button>
        </div>
      )}
      <video
        onClick={controls ? togglePlay : () => {}}
        ref={videoRef}
        poster={poster}
        preload="metadata"
        controlsList="nodownload nofullscreen noremoteplayback"
        muted={mute}
        playsInline
        autoPlay={autoPlay}
        loop={loop}
        style={{ cursor: controls && "pointer" }}
      />
    </div>
  );
}
